"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var ver = React.version.split('.').map(parseFloat);
function version() {
    return ver;
}
exports.version = version;
function batchedUpdates(cb) {
    ReactDOM.unstable_batchedUpdates(cb);
}
exports.batchedUpdates = batchedUpdates;
